export enum DialogView {
  Main = 'main',
  ExternalAppConfig = 'external-app-config',
}

export enum SlackChannelTypes {
  DIRECT = 'on_direct_mention',
  MENTION = 'on_mention_in_channel',
}

export const SlackTriggerConfig = {
  [SlackChannelTypes.MENTION]: {
    title: 'On mention in a channel',
    description: 'Triggers when mentioned in a Slack channel',
  },
  [SlackChannelTypes.DIRECT]: {
    title: 'On direct mention',
    description: 'Triggers when directly mentioned in Slack',
  },
} as const
